/**
 * Maps app language codes to BCP 47 locales for Intl date/time formatting.
 * Used to display dates and times in the user's selected language.
 */
const LANGUAGE_TO_LOCALE = {
  en: 'en-US',
  de: 'de-DE',
  fr: 'fr-FR',
  it: 'it-IT',
  es: 'es-ES',
  pt: 'pt-PT',
  ru: 'ru-RU',
  pl: 'pl-PL',
  nl: 'nl-NL',
  tr: 'tr-TR',
  el: 'el-GR',
  cs: 'cs-CZ',
  hu: 'hu-HU',
  ro: 'ro-RO',
  bg: 'bg-BG',
  hr: 'hr-HR',
  sl: 'sl-SI',
  sk: 'sk-SK',
  sv: 'sv-SE',
  no: 'nb-NO',
  da: 'da-DK',
  fi: 'fi-FI',
  zh: 'zh-CN',
  hi: 'hi-IN',
  ar: 'ar-SA',
  ja: 'ja-JP',
  ko: 'ko-KR',
  vi: 'vi-VN',
  id: 'id-ID',
  ms: 'ms-MY',
  bn: 'bn-BD',
  ta: 'ta-IN',
  te: 'te-IN',
  mr: 'mr-IN',
};

const DATE_OPTIONS = {
  weekday: 'short',
  year: 'numeric',
  month: 'short',
  day: 'numeric',
};

const TIME_OPTIONS = {
  hour: '2-digit',
  minute: '2-digit',
};

/**
 * Format a date and time for display in the schedule note, using the user's language.
 * @param {Date} date - The date to format
 * @param {Date} [time] - Optional separate time (if not provided, uses date's time)
 * @param {string} language - Language code (e.g. 'en', 'de', 'fr')
 * @param {string} atTimeStr - Translated "at" connector from strings.at_time (e.g. 'um', 'at', 'alle')
 * @returns {string} Formatted date and time string
 */
export const formatScheduleDateTime = (date, time, language, atTimeStr) => {
  const locale = LANGUAGE_TO_LOCALE[language] || LANGUAGE_TO_LOCALE.en;
  const dateToFormat = date instanceof Date ? date : new Date(date);
  const timeToFormat = time instanceof Date ? time : dateToFormat;
  const connector = (atTimeStr && atTimeStr.trim()) ? ` ${atTimeStr.trim()} ` : ' at ';

  const dateStr = dateToFormat.toLocaleDateString(locale, DATE_OPTIONS);
  const timeStr = timeToFormat.toLocaleTimeString(locale, TIME_OPTIONS);

  return `${dateStr}${connector}${timeStr}`;
};
